import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function PlatformTrustBar() {
  return <section className="w-full bg-darkCard/30 py-12 px-4" data-id="element-192">
      <FadeIn className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-193">
        <h3 className="text-cream/50 uppercase tracking-widest text-sm font-lato mb-8 text-center" style={{
        fontVariant: 'small-caps'
      }} data-id="element-194">
          Your new pieces will be ready for:
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 w-full max-w-3xl" data-id="element-195">
          <div className="bg-darkCard border border-darkBorder rounded-xl px-4 md:px-6 py-4 flex items-center justify-center gap-3" data-id="element-196">
            <span className="text-2xl" aria-hidden="true" data-id="element-197">
              🛍️
            </span>
            <span className="font-lato font-bold text-cream" data-id="element-198">Etsy</span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl px-4 md:px-6 py-4 flex items-center justify-center gap-3" data-id="element-199">
            <span className="text-2xl" aria-hidden="true" data-id="element-200">
              🛒
            </span>
            <span className="font-lato font-bold text-cream" data-id="element-201">Shopify</span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl px-4 md:px-6 py-4 flex items-center justify-center gap-3" data-id="element-202">
            <span className="text-2xl" aria-hidden="true" data-id="element-203">
              📸
            </span>
            <span className="font-lato font-bold text-cream" data-id="element-204">Instagram</span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl px-4 md:px-6 py-4 flex items-center justify-center gap-3" data-id="element-205">
            <span className="text-2xl" aria-hidden="true" data-id="element-206">
              🎵
            </span>
            <span className="font-lato font-bold text-cream" data-id="element-207">TikTok Shop</span>
          </div>
        </div>
      </FadeIn>
    </section>;
}